import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SplitScreen"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 3H12.75V21H11.25V3ZM7.5 5.25V18.75H3V5.25H7.5ZM7.5 3.75H3C2.17157 3.75 1.5 4.42157 1.5 5.25V18.75C1.5 19.5784 2.17157 20.25 3 20.25H7.5C8.32843 20.25 9 19.5784 9 18.75V5.25C9 4.42157 8.32843 3.75 7.5 3.75ZM21 5.25V18.75H16.5V5.25H21ZM21 3.75H16.5C15.6716 3.75 15 4.42157 15 5.25V18.75C15 19.5784 15.6716 20.25 16.5 20.25H21C21.8284 20.25 22.5 19.5784 22.5 18.75V5.25C22.5 4.42157 21.8284 3.75 21 3.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SplitScreen.vue"]]);
